import { CREATE_LESSON_RESOURCES, CREATE_LESSON, GET_LESSON, SET_ALL_COURSES, SET_ALL_LESSONS, UPDATE_COURSE, UPDATE_LESSON, UPLOAD_LESSON_RESOURCES } from "../../reducerTypes"

const initialState = {
  getData: {},
  getList: []
}

const lessonReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_LESSONS:
      return{
        ...state,
        getList: action.payload
      }
    case CREATE_LESSON:
      return{
        ...state,
        currentInstuctor: action.payload
      }
    case CREATE_LESSON_RESOURCES:
      return{
        ...state,
        currentInstuctor: action.payload
      }
    case GET_LESSON:
    return{
      ...state,
      getData: action.payload
    }
    case UPLOAD_LESSON_RESOURCES:
    return{
      ...state,
      getData: action.payload
    }
    case UPDATE_LESSON: 
    return{
      ...state,
      currentInstuctor: action.payload
    }
    default:
      return state
  }
}

export default lessonReducer
